var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendSqaure2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82002C4.18002 2 2.01001 4.17 2.01001 7.81V16.18C2.01001 19.82 4.18002 21.99 7.82002 21.99H16.19C19.83 21.99 22 19.82 22 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16985 14.09C9.35985 14.09 9.54985 14.02 9.69985 13.87L14.0799 9.49004V11.92C14.0799 12.33 14.4199 12.67 14.8299 12.67C15.2399 12.67 15.5799 12.33 15.5799 11.92V7.68005C15.5799 7.58005 15.5599 7.49005 15.5199 7.39005C15.4399 7.21005 15.2998 7.06005 15.1098 6.98005C15.0198 6.94005 14.9199 6.92004 14.8199 6.92004H10.5799C10.1699 6.92004 9.82985 7.26004 9.82985 7.67004C9.82985 8.08004 10.1699 8.42004 10.5799 8.42004H13.0098L8.62985 12.8C8.33985 13.09 8.33985 13.57 8.62985 13.86C8.78985 14.02 8.97985 14.09 9.16985 14.09Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7099 16.2801C18.5799 15.8901 18.1599 15.6801 17.7599 15.8101C14.0399 17.0501 9.94993 17.0501 6.22993 15.8101C5.83993 15.6801 5.40994 15.8901 5.27994 16.2801C5.14994 16.6701 5.35994 17.1001 5.74994 17.2301C7.75994 17.9001 9.86994 18.2401 11.9899 18.2401C14.1099 18.2401 16.2199 17.9001 18.2299 17.2301C18.6299 17.0901 18.8399 16.6701 18.7099 16.2801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSqaure2);
export default __webpack_public_path__ + "static/media/send-sqaure-2.975409249ad962aa79f193ecb7034105.svg";
export { ForwardRef as ReactComponent };